module.exports = __webpack_public_path__ + "img/logo_ibk@3x.ae6f5445.png";